export enum AccionMesaType {
    ANIADIR = "aniadir",
    QUITAR = "quitar",    
  }
  